/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Chat_DescriptionInputs */

const en_meta_chat_description = /** @type {(inputs: Meta_Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the work, the problem or the system you have in mind and the assistant will talk through what an AI system could do about it, and what it would cost.`)
};

const lv_meta_chat_description = /** @type {(inputs: Meta_Chat_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprakstiet darbu, problēmu vai sistēmu, kas Jums padomā, un asistents pārrunās, ko AI sistēma varētu paveikt un cik tas maksātu.`)
};

/**
* | output |
* | --- |
* | "Describe the work, the problem or the system you have in mind and the assistant will talk through what an AI system could do about it, and what it would cost." |
*
* @param {Meta_Chat_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_chat_description = /** @type {((inputs?: Meta_Chat_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Chat_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_chat_description(inputs)
	return en_meta_chat_description(inputs)
});